const ScrollLottie = async (obj) => {

    // load lottie and scroll-trigger again
    await SystemJS.import('lottie');
    await SystemJS.import('scroll-trigger');
    await SystemJS.import('gsap');

    let anim = lottie.loadAnimation({
        container: document.querySelector(obj.target),
        renderer: 'svg',
        loop: false,
        autoplay: false,
        path: obj.path,
    });

    /*
     * Scrub Animation - Frames of Lottie files are hooked to scroll Position
     */

    let timeObj = { currentFrame: 0 } // determines from what frame the lottie animation goes to initial position
    //let endString = (obj.speed === "slow") ? "+=2000" : (obj.speed === "medium") ? "+=1000" : (obj.speed === undefined) ? "+=1250" : "+=500"

    gsap.registerPlugin(ScrollTrigger);

    ScrollTrigger.create({
        trigger: obj.trigger,
        scrub: .1,
        pin: false, // don't set this to true... it causes only problems
        start: window.innerWidth < 1100 ?
            window.innerWidth < 768 ? 'top 45px' : 'top 45px' :
            'top 45px', //45px to prevent delay
        end: window.innerWidth < 1100 ?
            window.innerWidth < 768 ? '+=400' : '+=400' :
            '+=400',
        //end: endString,
        //markers: true,
        onUpdate: self => {
            if (obj.duration) { // bind to scrolling /w decent aftermath of logo animation
                gsap.to(timeObj, {
                    duration: obj.duration,
                    currentFrame: Math.floor(Math.max(self.progress * (anim.totalFrames - 1), 0)),
                    onUpdate: () => {
                        anim.goToAndStop(timeObj.currentFrame, true);
                    },
                    ease: 'expo'
                })
            } else { // directly bind to scrolling
                anim.goToAndStop(Math.floor(Math.max(self.progress * (anim.totalFrames - 1), 0)), true)
            }
        },
    });

    /*
     * Auto Animation - After trigger the animation is played even if scrolling is stopped
     */

    /*let lottieAnim = gsap.timeline({
        scrollTrigger: {
            trigger: obj.trigger,
            start: window.innerWidth < 1100 ? window.innerWidth < 768 ? '45px top' : '45px top' : '45px top',
            end: window.innerWidth < 1100 ? window.innerWidth < 768 ? '+=100px' : '+=100px' : '+=100px',
            onEnter: playLottie,
            onEnterBack: playLottieReverse,
            onLeaveBack: playLottieReverse,
            //markers: true
        }
    })
    lottieAnim.to(obj.target, {})

    function playLottie (){
        lottie.setDirection(1)
        lottie.play()
    }

    function playLottieReverse() {
        lottie.setDirection(-1)
        lottie.play()
    }*/
};


